import React from 'react';

export const MetricsCard = ({ label, value, icon: Icon, trend, isNegative = false, className = '' }) => {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm border ${isNegative ? 'border-red-200 dark:border-red-800' : 'border-gray-200 dark:border-gray-700'} p-4 sm:p-6 ${className}`}>
      <div className="flex justify-between items-start gap-3">
        <div className="min-w-0 flex-1">
          <p className={`text-xs sm:text-sm font-medium ${isNegative ? 'text-red-600 dark:text-red-400' : 'text-gray-600 dark:text-gray-400'}`}>{label}</p>
          <p className={`text-lg sm:text-2xl font-bold mt-1 sm:mt-2 break-words ${isNegative ? 'text-red-600 dark:text-red-400' : 'text-gray-900 dark:text-white'}`}>{value}</p>
          {trend && (
            <p className={`text-xs sm:text-sm mt-2 ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
              {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
            </p>
          )}
        </div>
        {Icon && <Icon className={`w-6 h-6 sm:w-8 sm:h-8 ${isNegative ? 'text-red-600' : 'text-blue-600'} flex-shrink-0`} />}
      </div>
    </div>
  );
};
